import { useEffect, useRef } from 'react';
import i18n from '@Lang/i18n';
import HeaderLink from "./comp/HeaderLink"
import { Link, useHistory } from 'react-router-dom';
import logo from '@Images/ecos_logo.png';
import logoEn from '@Images/ecos_logo_en.png';

import { callService } from '@Views/utils/ServiceUtils';
import { getLanguage } from '@Views/utils/StringUtils';

const Header = ({ getMsg, routesJson, userInfo, setUserInfo }: any) => {
  const msg = getMsg();
  const routesMsg = getMsg('routes');
  const colorHashList = ['#/Login', '#/SignIn', '#/StatisticalResearchPublication/MainStatisticsPublication'];
  const headerRef: any = useRef();
  const history = useHistory();
  const win: any = window;
  const langOnChange = () => {
    const lang = i18n.language === 'ko' ? 'en' : 'ko';
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  }

  const urlChange = async () => {
    await callService("OBMUE01U01");
  }

  const headerChange = () => {
    const hash = window.location.hash;

    if (headerRef['current']['classList'].contains("header-main")) {
      headerRef['current']['classList'].remove('header-main');
    }

    for (const item of colorHashList) {
      if (hash.indexOf(item) !== -1) {
        headerRef['current']['classList'].add('header-main');
        break;
      }
    }

    if (hash === '#/') {
      headerRef['current']['classList'].add('header-main');
    }

  }

  const onMouseEnter = (e: any) => {
    if (headerRef['current']['classList'].contains("active") === false) {
      headerRef['current']['classList'].add('active');
    }
  }
  const onMouseLeave = (e: any) => {
    if (headerRef['current']['classList'].contains("active")) {
      headerRef['current']['classList'].remove('active');
    }
  }

  const logout = () => {

    const win: any = window;
    win.confirm(msg['header']['logoutMsg'], function () {
      sessionStorage.removeItem('userInfo');
      setUserInfo();
      history.push('/');
    })

  }

  const paramLangOnChange = () => {
    const hash = window.location.hash;
    const langCdText = '?langCd=en';

    if (hash.indexOf(langCdText) !== -1) {
      setTimeout(function () {
        i18n.changeLanguage('en');
        localStorage.setItem("lang", 'en');
      }, 10);
    }
  }

  useEffect(() => {
    paramLangOnChange();
    headerChange();
    urlChange();
    return history.listen(() => {
      paramLangOnChange();
      headerChange();
      urlChange();
    })
  }, [history])


  useEffect(() => {
    document.title = msg['header']['title'];


    if ('ko' === i18n.language) {
      win.RealPivotMessages = {
        notReadyText: "피벗 설정이 준비되지 않았습니다.",
        emptyDataText: "데이터가 존재하지 않습니다.",
        columnTotalText: "전체 요약",
        rowTotalText: "전체 요약",
        columnText: "열",
        rowText: "행",
        valueText: "값",
        countText: "건수",
        progressMessage: "피벗 화면 구성 중입니다...",

        valueTypeTexts: {
          sum: "합계",
          min: "최소",
          max: "최대",
          avg: "평균",
          count: "건수",
          distinct: "고유"
        },

        setupPanel: {
          headerText: "Pivot Setup",
          columnSectionText: "컬럼 필드 ",
          rowSectionText: "행 필드",
          valueSectionText: "값 필드",
          filterSectionText: "필터 필드",
          fieldSectionText: "전체 필드",
          valueConfigText: "설정",
          applyButtonText: "적용",
          cancelButtonText: "취소",
          fieldAddUnableText: "여기에 추가 할 수 없는 필드입니다.",
          fieldDuplicateText: "이미 존재하는 필드입니다.",
          filter: {
            headerText: "필터 설정",
            allText: "전체",
            expressionPlaceholder: "예) value > 0",
            applyButtonText: "확인",
            cancelButtonText: "취소"
          },
          value: {
            headerText: "값 설정",
            columnGroupText: "컬럼 값 기준 정렬",
            rowGroupText: "행 값 기준 정렬",
            formatGroupText: "표시형식",
            alignmentGroupText: "맞춤방식",
            selectNoConfigText: "설정하지 않음",
            selectConfigText: "설정",
            sortDirectionText: "정렬방식",
            sortAscendingText: "순차정렬",
            sortDescendingText: "역차정렬",
            emptyUpperOptionText: "상위 미지정",
            summaryOptionText: "합계",
            applyButtonText: "확인",
            cancelButtonText: "취소"
          }
        },

        numberFormatList: [{
          value: "",
          labelText: "지정 안함"
        }, {
          value: "#0",
          labelText: "일반(#0)"
        }, {
          value: "#,##0",
          labelText: "정수(#,##0)"
        }, {
          value: "#,##0.0",
          labelText: "소수점 1자리(#,##0.0)"
        }, {
          value: "#,##0.00",
          labelText: "소수점 2자리(#,##0.00)"
        }, {
          value: "#,##0.000",
          labelText: "소수점 3자리(#,##0.000)"
        }],
        userDefinedFormatText: "사용자 정의 포맷",
        alignmentList: [
          { value: null, labelText: "기본" },
          { value: "center", labelText: "중앙" },
          { value: "near", labelText: "좌측" },
          { value: "far", labelText: "우측" }
        ]
      };
    } else {
      win.RealPivotMessages = {
        notReadyText: "Pivot configuration is not ready.",
        emptyDataText: "There are no data.",
        columnTotalText: "Full summary",
        rowTotalText: "Full summary",
        columnText: "Column",
        rowText: "Row",
        valueText: "Value",
        countText: "Count",
        progressMessage: "Pivot is being created...",

        valueTypeTexts: {
          sum: "SUM",
          min: "MIN",
          max: "MAX",
          avg: "AVG",
          count: "COUNT",
          distinct: "DISTINCT"
        },

        setupPanel: {
          headerText: "Pivot Setup",
          columnSectionText: "Column Field",
          rowSectionText: "Row Field",
          valueSectionText: "Value Field",
          filterSectionText: "Filter Field",
          fieldSectionText: "All Fields",
          valueConfigText: "set",
          applyButtonText: "Apply",
          cancelButtonText: "Cancel",
          fieldAddUnableText: "This field can't be applied here.",
          fieldDuplicateText: "This feild is already existed.",
          filter: {
            headerText: "Filter configuration",
            allText: "All",
            expressionPlaceholder: "ex) value > 0",
            applyButtonText: "Apply",
            cancelButtonText: "Cancel"
          },
          value: {
            headerText: "How to display",
            columnGroupText: "Sort by Column value",
            rowGroupText: "Sort by Row value",
            formatGroupText: "Format",
            alignmentGroupText: "Alignment",
            selectNoConfigText: "off",
            selectConfigText: "on",
            sortDirectionText: "Order by",
            sortAscendingText: "Asc",
            sortDescendingText: "Desc",
            emptyUpperOptionText: "Upper undefine",
            summaryOptionText: "Sum",
            applyButtonText: "Apply",
            cancelButtonText: "Cancel"
          }
        },

        numberFormatList: [{
          value: "",
          labelText: "Undefined"
        }, {
          value: "#0",
          labelText: "Text(#0)"
        }, {
          value: "#,##0",
          labelText: "Integer(#,##0)"
        }, {
          value: "#,##0.0",
          labelText: "1 Decimal place(#,##0.0)"
        }, {
          value: "#,##0.00",
          labelText: "2 Decimal places(#,##0.00)"
        }, {
          value: "#,##0.000",
          labelText: "3 Decimal places(#,##0.000)"
        }],
        userDefinedFormatText: "User defined format",
        alignmentList: [
          { value: null, labelText: "Default" },
          { value: "center", labelText: "center" },
          { value: "near", labelText: "left" },
          { value: "far", labelText: "right" }
        ]
      };
    }

  }, [i18n.language])

  return (
    <div className="wrap-head">
      <div className="header header-yh" ref={headerRef}>
        <div className="depth2Bg" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}></div>
        <div className="header_innder clearfix" >
          <div className="gnb_leftFixTit">
            <h1 className="logo_default">
              {
                (window.location.href.indexOf('boknet.intra') === -1) ?
                  <Link className="logo_ecos" to='/'>
                    <span className="gnbTit">
                      {
                        (window.location.href.indexOf('ecos.bok.or.kr') === -1) ?
                          <div style={{ display: "flex", height: "20px" }}>
                            <img src={getLanguage() === 'ko' ? logo : logoEn} alt={msg['header']['title']}></img>
                            <p style={{ fontSize: "15px", color: "red", marginLeft: "11px" }}>(TEST)</p>
                          </div>
                          :
                          <img src={getLanguage() === 'ko' ? logo : logoEn} alt={msg['header']['title']}></img>
                      }
                    </span>
                  </Link>
                  :
                  <Link className="logo_ecos" to='/SearchStat'>
                    <span className="gnbTit">
                      {
                        (window.location.href.indexOf('ecos.boknet.intra') === -1) ?
                          <div style={{ display: "flex", height: "20px" }}>
                            <img src={getLanguage() === 'ko' ? logo : logoEn} alt={msg['header']['title']}></img>
                            <p style={{ fontSize: "15px", color: "red", marginLeft: "11px" }}>(TEST)</p>
                          </div>
                          :
                          <img src={getLanguage() === 'ko' ? logo : logoEn} alt={msg['header']['title']}></img>
                      }
                    </span>
                  </Link>
              }
            </h1>
          </div>

          <div className="gnbMenu" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onFocus={onMouseEnter} >
            <ul className={"menu_list" + (getLanguage() === 'en' ? ' addEn' : '')}>
              <HeaderLink routesMsg={routesMsg} routesJson={routesJson} history={history} />
            </ul>
          </div>

          {
            (window.location.href.indexOf('boknet.intra') === -1) &&
            <div className="gnb_rightOptions" onFocus={onMouseLeave}>
              <ul className="gnbOptions">
                <li className="optionMenu partition-right">
                  <Link to='/' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/') } }}>{msg['header']['home']}</Link>
                </li>
                {
                  i18n.language === 'ko' &&
                  <>
                    {
                      userInfo ?
                        <>
                          <li className="optionMenu partition-right">
                            <Link to='/Profile' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/Profile') } }}>{msg['header']['profile']}</Link>
                          </li>
                          <li className="optionMenu partition-right">
                            <a onClick={logout} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { logout() } }}>{msg['header']['logOut']}</a>
                          </li>
                        </>
                        :
                        <li className="optionMenu partition-right">
                          <Link to='/Login' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/Login') } }}>{msg['header']['login']}</Link>
                        </li>
                    }
                  </>
                }
                <li className="optionMenu partition-right">
                  <Link to='/ECOSHelp' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/Login') } }} >{msg['header']['ecosHelp']}</Link>
                </li>
                <li className="optionMenu">
                  <Link to='#' onKeyUp={(e) => { if (e['code'] === 'Space') { langOnChange() } }} className={"langChange " + (i18n.language === "ko" ? "langEn" : "langKo")} onClick={langOnChange}>{msg['header']['lang']}</Link>
                </li>
              </ul>
            </div>
          }

        </div>
      </div>
    </div>
  );
}

export default Header;